import { EventVisibleStatus } from '../../../../../mainv2/types/event';

type EventLike = {
  status: EventVisibleStatus;
  capacity: number;
  active_reservation_count: number;
};

export class EventStatusUtils {
  static shouldDisable(alreadyReserved: boolean, event: EventLike): boolean {
    return alreadyReserved || this.isEventFull(event);
  }
  static isEventFull(event): boolean {
    return event.capacity === event.active_reservation_count || event.full;
  }
  static getButtonText(alreadyReserved: boolean, event: EventLike): string {
    if (alreadyReserved) {
      return '予約済み';
    }
    if (this.isEventFull(event)) {
      return '満員御礼';
    }
    return 'このイベントを予約する';
  }
}
